import { FormBuilder } from "./FormBuilder";
import { FormBuilderProps, FormBuilderType, validatorFunc, FormBuilderState } from "./FormBuilder.types";
import {
  email,
  required,
  regex,
  password,
  minChar,
  maxChar,
  alphaOnly,
  numericOnly,
  charLength,
  custom,
} from "./lib/FormBuilderValidator";

const FormBuilderValidator = {
  email,
  required,
  regex,
  password,
  minChar,
  maxChar,
  alphaOnly,
  numericOnly,
  charLength,
  custom,
};

export { FormBuilder, FormBuilderProps, FormBuilderType, FormBuilderValidator, validatorFunc, FormBuilderState };
